import React from 'react';
import { styled as materialStyled } from '@mui/material/styles';
import { Grid, Typography, Box } from '@mui/material';
import { SubordinatePermissions } from '../../../../redux/subordinate/subordinateSlice';
import RedCross from '../../../../assets/img/close-icon-red.svg';
import GreenTick from '../../../../assets/img/green-tick.svg';

const CustomGridItem = materialStyled(Grid)(() => ({
  paddingBottom: '12px',
  overflowWrap: 'break-word',
}));

interface ViewSubordinatePermissionModelProps {
  permissions: SubordinatePermissions[] | undefined;
}
const ViewSubordinatePermissionModel = ({ permissions }: ViewSubordinatePermissionModelProps) => (
  <Grid container rowGap="8px" mt="12px">
    <Grid item xs={12}>
      {' '}
      <Typography variant="textXS" color="#6F7C8E">
        Permissions
      </Typography>
    </Grid>

    {permissions?.map((permission: SubordinatePermissions) => (
      <CustomGridItem item xs={6} key={permission.permissionId}>
        <Box
          component="img"
          src={permission.activeStatus ? GreenTick : RedCross}
          pr="4px"
          alt={permission.activeStatus ? 'GreenTick' : 'RedCross'}
        />
        <Typography variant="textBase" textTransform="capitalize">
          {permission.permissionDescription}
        </Typography>
      </CustomGridItem>
    ))}
  </Grid>
);

export default ViewSubordinatePermissionModel;
